import Day from "../Day"

export default function Week(props) {

    return (
        <div className="flex-container flex-horizontal column-space-between-container">
            {props.days.map((day, index) => {
                return <Day {...day} onChange={props.onChange} controllers={props.controllers} key={index + "_" + day.newDate.dayInt} />
            })
            }
        </div>
    )
} 